import { Controller } from "stimulus"

// #1263 (Sam, 20-10-2026): Compact | Normaal | Uitgebreid in het rooster. De
// keuze zet data-dichtheid op het rooster (de uurhoogte in appointments/stijl)
// en wordt per gebruiker in deze browser onthouden. Kan de browser niets
// opslaan (privévenster), dan geldt de keuze tot de volgende pagina. Zonder
// JavaScript blijven de knoppen verborgen en is het rooster Normaal.
const DICHTHEDEN = ["compact", "normaal", "uitgebreid"]

export default class extends Controller {
  static targets = ["knoppen", "knop"]
  static values = { gebruiker: String }

  connect() {
    this.zet(this.lees() || "normaal")
    if (this.hasKnoppenTarget) this.knoppenTarget.hidden = false
  }

  kies(event) {
    const dichtheid = event.currentTarget.dataset.dichtheid
    if (!DICHTHEDEN.includes(dichtheid)) return
    this.zet(dichtheid)
    this.bewaar(dichtheid)
  }

  zet(dichtheid) {
    this.element.dataset.dichtheid = dichtheid
    this.knopTargets.forEach((knop) => {
      const actief = knop.dataset.dichtheid === dichtheid
      knop.classList.toggle("is-actief", actief)
      knop.setAttribute("aria-pressed", actief ? "true" : "false")
    })
  }

  get sleutel() {
    return `cc-rooster-dichtheid-${this.gebruikerValue || "ik"}`
  }

  lees() {
    try {
      const waarde = window.localStorage.getItem(this.sleutel)
      return DICHTHEDEN.includes(waarde) ? waarde : null
    } catch (e) {
      return null
    }
  }

  bewaar(dichtheid) {
    try {
      window.localStorage.setItem(this.sleutel, dichtheid)
    } catch (e) {
      // niet opslaan kan: de keuze geldt dan alleen op deze pagina
    }
  }
}
